import React from "react";

// Minimal markdown for Copilot replies: headings, bullets, numbered lists, **bold**, `code`.
function inline(text) {
  return text.split(/(\*\*[^*]+\*\*|`[^`]+`)/g).map((part, i) => {
    if (part.startsWith("**") && part.endsWith("**") && part.length > 4) return <strong key={i} className="font-semibold text-fg">{part.slice(2, -2)}</strong>;
    if (part.startsWith("`") && part.endsWith("`") && part.length > 2) return <code key={i} className="font-mono-tabular text-[12px] px-1 bg-bg rounded-sm">{part.slice(1, -1)}</code>;
    return part;
  });
}

export default function ReplyText({ text }) {
  const lines = (text || "").split("\n");
  return (
    <div className="whitespace-normal space-y-1">
      {lines.map((raw, i) => {
        const line = raw.trimEnd();
        if (!line.trim()) return <div key={i} className="h-1" />;
        const h = line.match(/^#{1,6}\s+(.*)$/);
        if (h) return <div key={i} className="font-semibold text-fg mt-1">{inline(h[1])}</div>;
        const b = line.match(/^\s*[-*•]\s+(.*)$/);
        if (b) return <div key={i} className="flex gap-2 pl-1"><span className="text-primary">•</span><span>{inline(b[1])}</span></div>;
        const n = line.match(/^\s*(\d+)[.)]\s+(.*)$/);
        if (n) return <div key={i} className="flex gap-2 pl-1"><span className="text-primary font-mono-tabular">{n[1]}.</span><span>{inline(n[2])}</span></div>;
        return <p key={i}>{inline(line)}</p>;
      })}
    </div>
  );
}
